import { render, staticRenderFns } from "./dict-manage.vue?vue&type=template&id=c90f1dd2&scoped=true&"
import script from "./dict-manage.vue?vue&type=script&lang=js&"
export * from "./dict-manage.vue?vue&type=script&lang=js&"
import style0 from "./dict-manage.vue?vue&type=style&index=0&id=c90f1dd2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c90f1dd2",
  null
  
)

export default component.exports